import { IpiForm } from 'app/components/Profile/Ids/IpiDialog/types';
import { getDirtyValues } from 'app/utils/utils';
import { toUpdateIpiData } from 'app/components/Profile/Ids/IpiDialog/utils';
import { UseFormHandleSubmit } from 'react-hook-form';
import { Ipi, UpdateIpiData } from 'types/ipi.types';
import { FormState } from 'react-hook-form/dist/types/form';
import { Link } from 'types/api.types';
import { SocietyOption } from 'app/components/Profile/Ids/types';
import { useAppDispatch } from 'app/store';
import { updateProfileEffect } from 'app/store/Profile/effects';

interface UseIpiDialogSubmitProps {
  handleSubmit: UseFormHandleSubmit<IpiForm>;
  dirtyFields: FormState<IpiForm>['dirtyFields'];
  ipi?: Ipi;
  updateIpi: (formData: Partial<UpdateIpiData>, link?: Link) => Promise<Ipi>;
  handleClose: () => void;
  handleAddIpiV0: (data: Partial<IpiForm>) => Promise<void>;
  handleAddIpiV2: (data: IpiForm) => Promise<void>;
  handleAddIpiV3: (data: SocietyOption) => void;
}

export const useIpiDialogSubmit = ({
  handleSubmit,
  dirtyFields,
  ipi,
  updateIpi,
  handleClose,
  handleAddIpiV0,
  handleAddIpiV2,
  handleAddIpiV3,
}: UseIpiDialogSubmitProps) => {
  const dispatch = useAppDispatch();
  const onSubmit = handleSubmit(async (values: IpiForm) => {
    if (!values.society) return;
    try {
      if (ipi) {
        const { isDefault, ...dirtyValues } = getDirtyValues<IpiForm>(
          dirtyFields,
          values
        );
        await updateIpi(toUpdateIpiData(dirtyValues), ipi._links?.updateIpi);
        if (isDefault !== undefined) {
          const value = isDefault ? ipi.ipiNameNumber : null;
          await dispatch(
            updateProfileEffect({
              formData: {
                preferredIpi: { title: '', value: value as number },
              },
              options: { hideAlerts: true },
            })
          ).unwrap();
        }
        handleClose();
        return;
      }

      const {
        isDefault,
        ipiNameNumber,
        society: { verification },
      } = values;

      switch (verification?.version) {
        case 2:
          await handleAddIpiV2(values);
          break;
        case 3:
          handleAddIpiV3(values.society);
          break;
        default: {
          const dirtyValues = getDirtyValues<IpiForm>(dirtyFields, values);
          await handleAddIpiV0(dirtyValues);
          break;
        }
      }
      if (isDefault !== undefined) {
        const value = isDefault ? ipiNameNumber : null;
        await dispatch(
          updateProfileEffect({
            formData: {
              preferredIpi: { title: '', value: value as string },
            },
            options: { hideAlerts: true },
          })
        ).unwrap();
      }
    } catch (e) {
      // Proceed regardless
    }
  });

  return {
    onSubmit,
  };
};
